import { ValidatorFn } from '@angular/forms'
import { ListValidator } from '../list/list.validator'
import { IntegerIdValidator } from './integer-id.validator'

export const IntegerIdListValidator: ValidatorFn =
  ListValidator(IntegerIdValidator)
